import admin from "./en/admin.json";
import common from "./en/common.json";
import error from "./en/error.json";
import groups from "./en/groups.json";
import library from "./en/library.json";
import userLogin from "./en/userLogin.json";
import users from "./en/users.json";
import media from "./en/media.json";
import categories from "./en/categories.json";
import tags from "./en/tags.json";
import fileDropZone from "./en/fileDropZone.json";
import client from "./en/client.json";
import comments from "./en/comments.json";
import news from "./en/news.json";
import roles from "./en/roles.json";
import zones from "./en/zones.json";
import contacts from "./en/contacts.json";
import accreditation from "./en/accreditation.json";
import help from "./en/help.json";
import profile from "./en/profile.json";
import reports from "./en/reports.json";
import notifications from "./en/notifications.json";
import feedback from "./en/feedback.json";
import assets from "./en/assets.json";
import widgets from "./en/widgets.json";
import recordLock from "./en/recordLock.json";
import settings from "./en/settings.json";
import tenants from "./en/tenants.json";
import apps from "./en/apps.json";
import favourites from "./en/favourites.json";
import fragments from "./en/fragments.json";
import links from "./en/links.json";
import tiptap from "./en/tiptap.json";
import videoPlayer from "./en/videoPlayer.json";
import audioPlayer from "./en/audioPlayer.json";
import search from "./en/search.json";
import decisionTrees from "./en/decisionTrees.json";
import forms from "./en/forms.json";
import schematics from "./en/schematics.json";
import dialogs from "./en/dialogs.json";
import nlvManager from "./en/nlvmanager.json";
import glossary from "./en/glossary.json";

export const en = {
  common: common,
  userLogin: userLogin,
  admin: admin,
  error: error,
  groups: groups,
  users: users,
  media: media,
  categories,
  tags: tags,
  fileDropZone: fileDropZone,
  library: library,
  client: client,
  comments: comments,
  news: news,
  roles: roles,
  zones: zones,
  contacts: contacts,
  accreditation: accreditation,
  help: help,
  profile: profile,
  reports: reports,
  notifications: notifications,
  feedback: feedback,
  assets: assets,
  widgets: widgets,
  recordLock: recordLock,
  settings: settings,
  tenants: tenants,
  apps: apps,
  favourites: favourites,
  fragments: fragments,
  links: links,
  tiptap: tiptap,
  videoPlayer: videoPlayer,
  audioPlayer: audioPlayer,
  search: search,
  decisionTrees: decisionTrees,
  forms: forms,
  dialogs: dialogs,
  schematics: schematics,
  nlvManager: nlvManager,
  glossary: glossary,
};
